module.exports = __webpack_public_path__ + "img/marcato_brown_natural1.2ce3ef8f.jpg";